import React, {useEffect, useRef, useState} from 'react';
import {useError} from "../../hooks/useError";
import {getMediaFile} from "../../services/CourseRepository";

export function SVGFromUrl({ url, className }) {
    const [svgContent, setSvgContent] = useState(null);
    const containerRef = useRef(null);
    const {setErrorMessage} = useError();

    useEffect(() => {
        getMediaFile(url)
            .then(setSvgContent)
            .catch((err) => {
                console.error(err);
                setSvgContent('<svg><text x="0" y="15" fill="red">Error loading SVG</text></svg>');
            });
    }, [url]);


    // Post-process the SVG after it's injected
    useEffect(() => {
        if (!containerRef.current) return;
        const svg = containerRef.current.querySelector('svg');

        if (svg) {
            svg.removeAttribute('width');
            svg.removeAttribute('height');
            svg.setAttribute('width', '100%');
            svg.setAttribute('height', '100%');

            // Ensure viewBox exists for proper scaling
            if (!svg.getAttribute('viewBox')) {
                const bbox = svg.getBBox?.();
                if (bbox) {
                    svg.setAttribute('viewBox', `0 0 ${bbox.width} ${bbox.height}`);
                }
            }

            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        }
    }, [svgContent]);

    return (
        <div
            ref={containerRef}
            className={"svg "+className}
            dangerouslySetInnerHTML={{ __html: svgContent }}
        />
    );
}
